import { render, staticRenderFns } from "./ac-my-simple-card.vue?vue&type=template&id=1f4dd005&"
import script from "./ac-my-simple-card.vue?vue&type=script&lang=js&"
export * from "./ac-my-simple-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports